// covered-by: qa/rickrubin/tests/specs/cca/ask.puntt.3pane.spec.ts
// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import {
  legacyChatSearchToNavigate,
  replacePathRedirect,
} from "./askPunttPaths";
import AskPunttChat from "./chat";
import { parseChatSearch } from "./chatSearch";

import PendingComponent from "../../components/PendingComponent";
import { canAccessAskPuntt } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

export { chatSearch, parseChatSearch, type ChatSearch } from "./chatSearch";

export const askPunttChatRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "ask-puntt/$chatId",
  validateSearch(search: Record<string, unknown>) {
    return parseChatSearch(search);
  },
  beforeLoad({
    params,
    search,
  }: {
    params: { chatId: string };
    search: Record<string, unknown>;
  }) {
    if (!canAccessAskPuntt()) {
      throw redirect({ to: ticketsRoute.to });
    }
    const parsed = parseChatSearch(search);
    const commentRaw =
      typeof search.comment === "string" ? search.comment.trim() : undefined;
    const target = legacyChatSearchToNavigate(params.chatId, {
      ...parsed,
      comment: commentRaw,
    });
    if (target) {
      throw redirect(replacePathRedirect(target) as never);
    }
  },
  component: AskPunttChat,
  pendingComponent: PendingComponent,
  gcTime: 0,
  shouldReload: true,
  pendingMs: 0,
  pendingMinMs: 500,
});
